import lodash from "lodash";
import Base from "../base.store";

const baseUrl = "/api/v1/transaction/stock-cards";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        getStorageLocationSubReserveAndUse(context, { stroageLocationSubId, config }) {
            const body = [];
            if (Array.isArray(stroageLocationSubId)) {
                body.push(...stroageLocationSubId);
            } else {
                body.push(stroageLocationSubId);
            }
            return base.request
                .post(`${baseUrl}/storage-location-sub/reserve-use`, body, { ...config })
                .then(reserveUses => (Array.isArray(stroageLocationSubId) ? reserveUses : reserveUses[0]));
        },
        getHazLicenseReserveAndUse(context, { hazLicenseId, config }) {
            const body = [];
            if (Array.isArray(hazLicenseId)) {
                body.push(...hazLicenseId);
            } else {
                body.push(hazLicenseId);
            }
            return base.request
                .post(`${baseUrl}/haz-license/reserve-use`, body, { ...config })
                .then(reserveUses => (Array.isArray(hazLicenseId) ? reserveUses : reserveUses[0]));
        }
    },
    mutations: {
        ...base.mutations
    }
};
